import { useState, useEffect } from 'react';

const ADMIN_MODE_KEY = 'teufel_admin_mode';

export const useAdminMode = () => {
    const [adminMode, setAdminMode] = useState(false);

    useEffect(() => {
        // Load from localStorage on mount
        const stored = localStorage.getItem(ADMIN_MODE_KEY);
        if (stored !== null) {
            setAdminMode(stored === 'true');
        }
    }, []);

    const toggleAdminMode = () => {
        const newValue = !adminMode;
        setAdminMode(newValue);
        localStorage.setItem(ADMIN_MODE_KEY, newValue.toString());
    };

    return { adminMode, toggleAdminMode };
};
